/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaSourceResponse model module.
 * @module model/AqaSourceResponse
 * @version v0
 */
export default class AqaSourceResponse {
  /**
   * Constructs a new <code>AqaSourceResponse</code>.
   * @alias module:model/AqaSourceResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaSourceResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaSourceResponse} obj Optional instance to populate.
   * @return {module:model/AqaSourceResponse} The populated <code>AqaSourceResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaSourceResponse();
      if (data.hasOwnProperty('success'))
        obj.success = ApiClient.convertToType(data['success'], 'Boolean');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('timestamp'))
        obj.timestamp = ApiClient.convertToType(data['timestamp'], 'Number');
      if (data.hasOwnProperty('successful'))
        obj.successful = ApiClient.convertToType(data['successful'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Boolean} success
 */
AqaSourceResponse.prototype.success = undefined;

/**
 * @member {String} message
 */
AqaSourceResponse.prototype.message = undefined;

/**
 * @member {String} id
 */
AqaSourceResponse.prototype.id = undefined;

/**
 * @member {String} name
 */
AqaSourceResponse.prototype.name = undefined;

/**
 * @member {String} description
 */
AqaSourceResponse.prototype.description = undefined;

/**
 * @member {Number} timestamp
 */
AqaSourceResponse.prototype.timestamp = undefined;

/**
 * @member {Boolean} successful
 */
AqaSourceResponse.prototype.successful = undefined;

